import { render, staticRenderFns } from "./BenefitsRow.vue?vue&type=template&id=538d9bab"
import script from "./BenefitsRow.vue?vue&type=script&lang=js"
export * from "./BenefitsRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports